import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";
import { ProductAdjustmentType } from "../types/ProductAdjustment";

export const GET_PRODUCT_ADJUSTMENT_TYPES_FETCH_KEY =
  "@CORE_PRODUCTS_GET_PRODUCT_ADJUSTMENT_TYPES_KEY";

export const getProductAdjustmentTypes = async () => {
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/product-adjustment-types`,
  );
  return response.data;
};

export const useGetProductAdjustmentTypes = () => {
  const { data, error, isPending, refetch } = useQuery<
    ProductAdjustmentType[],
    Error
  >({
    queryKey: [GET_PRODUCT_ADJUSTMENT_TYPES_FETCH_KEY],
    queryFn: () => getProductAdjustmentTypes(),
    placeholderData: keepPreviousData,
  });
  return {
    data: data || [],
    error,
    isPending,
    refetch,
  };
};
